document.addEventListener('DOMContentLoaded', () => {
	preselectCrossSellVariant();
	document.addEventListener('click', onCrossSellButtonClick);
	document.addEventListener('change', onCrossSellItemsChange);
	document.addEventListener('variant:change', onVariantChange);
});

// EVENT HANDLERS

function onVariantChange() {
	const activeVariantId = getActiveVariantId();
	if (!activeVariantId) return;

	const root = getCrossSellRoot(activeVariantId);
	if (!root) return;
	updateCrossSellPrice(root);
}

function onCrossSellItemsChange(event) {
	if (!event.target.matches('.cross-sell-item__cb')) return;
	const root = event.target.closest('.cross-sell-variants');
	if (!root) return;
	updateCrossSellPrice(root);
}

function onCrossSellButtonClick(event) {
	const button = event.target.closest('button[data-cross-sell-product="true"]');
	if (!button) return;
	event.preventDefault();
	event.stopPropagation();
	handleCrossSellAdd();
}

function preselectCrossSellVariant() {
	const params = new URLSearchParams(window.location.search);
	if (params.has('variant')) return;

	const firstCrossSellRadio = document.querySelector('.cross-variant-picker__input[data-cross-sell="true"]');
	if (!firstCrossSellRadio) return;

	document.querySelectorAll('.cross-variant-picker__input').forEach((input) => (input.checked = false));
	firstCrossSellRadio.checked = true;
	firstCrossSellRadio.dispatchEvent(new Event('change', { bubbles: true }));

	const form = firstCrossSellRadio.closest('form');
	if (!form) return;

	form.dispatchEvent(
		new CustomEvent('variant:change', {
			bubbles: true,
			detail: { variantId: firstCrossSellRadio.value },
		}),
	);
}

async function handleCrossSellAdd() {
	const mainVariantId = getActiveVariantId();
	if (!mainVariantId) return;

	const selectedRadio = document.querySelector('.cross-variant-picker__input:checked');
	const discountAttrKey = selectedRadio?.dataset.crossSellAttrKey || '';
	const qty = 1;

	const items = buildCartItems(mainVariantId, discountAttrKey, qty);

	try {
		const sectionsToBundle = [];
		document.documentElement.dispatchEvent(
			new CustomEvent('cart:prepare-bundled-sections', {
				bubbles: true,
				detail: { sections: sectionsToBundle },
			}),
		);

		await addItemsToCart(items, sectionsToBundle);
	} catch (err) {
		console.error('Add to cart failed', err);
	}
}

function buildCartItems(mainVariantId, discountAttrKey, qty) {
	const crossSellID = crypto?.randomUUID?.() ||  `${Date.now()}-${Math.random().toString(16).slice(2)}`;

	const parentProps = {
		_cross_sell_id: crossSellID,
		_cross_sell_role: 'parent'
	}
	//if(discountAttrKey) parentProps[discountAttrKey] = 'parent'
	const items = [
		{
			id: mainVariantId,
			quantity: qty,
			properties: parentProps || {},
		},
	];

	const root = getCrossSellRoot(mainVariantId);
	if (!root) return items;

	root.querySelectorAll('.cross-sell-item__cb:checked').forEach((cb) => {
		const wrapper = cb.closest('.cross-sell__item');
		const childId = Number(wrapper?.dataset.variantId);

		const childProps = {
      _cross_sell_id: crossSellID,
      _cross_sell_role: 'child',
      _parent_set: String(mainVariantId)
    };
		//if (discountAttrKey) childProps[discountAttrKey] = 'child';
		if (!childId) return;
		items.push({
			id: childId,
			quantity: qty,
			properties: childProps || {},
		});
	});

	return items;
}

async function addItemsToCart(items, sectionsToBundle) {
	const headers = { 'Content-Type': 'application/json' };
	const sections = sectionsToBundle.join(',');
	const sectionsUrl = window.location.pathname;
	const addRes = await fetch(`${Shopify.routes.root}cart/add.js`, {
		method: 'POST',
		headers,
		body: JSON.stringify({
			items,
			sections,
			sections_url: sectionsUrl,
		}),
	});
	if (!addRes.ok) throw new Error('Cart add failed');

	// fetch update to retreive full cart and trigger theme's cart drawer logic
	const updateRes = await fetch(`${Shopify.routes.root}cart/update.js`, {
		method: 'POST',
		headers,
		body: JSON.stringify({
			updates: {},
			sections,
			sections_url: sectionsUrl,
		}),
	});
	if (!updateRes.ok) throw new Error('Cart update failed');

	const fullCart = await updateRes.json();
	document.documentElement.dispatchEvent(
		new CustomEvent('cart:change', {
			bubbles: true,
			detail: {
				baseEvent: 'variant:add',
				onSuccessDo: 'force_open_drawer',
				cart: fullCart,
			},
		}),
	);
}

function updateCrossSellPrice(root) {
  const parentId = Number(root.dataset.parentVariantId);
  const crossSellBundleData = window.bundlePrices[parentId];
  if (!crossSellBundleData) return;

  let compareTotal = crossSellBundleData.comparePrice;
  let currentTotal = crossSellBundleData.basePrice;

  crossSellBundleData.items.forEach(item => {
    const wrapper = root.querySelector(`.cross-sell__item[data-variant-id="${item.id}"]`);
    const checkbox = wrapper?.querySelector('.cross-sell-item__cb');
    if (!checkbox?.checked) return;

    compareTotal += item.comparePrice;
    currentTotal += item.discountedPrice;
  });

  const variantItemWrapper = root.closest('.cross-variant-picker__variant-details');
  const variantItem = variantItemWrapper?.querySelector('.cross-variant-picker__variant-item');
  if (!variantItem) return;

  updatePriceElements(variantItemWrapper, variantItem, currentTotal, compareTotal);
  updateGlobalCrossSellPrices(parentId, currentTotal, compareTotal);
}

function updatePriceElements(variantItemWrapper, variantItem, currentTotal, compareTotal) {
	const priceEl = variantItem.querySelector('.cross-variant-picker__variant-price');
	const compareAtPriceEl = variantItem.querySelector('.cross-variant-picker__compare-price');
	const discountBadge = variantItemWrapper?.querySelector('.cross-variant__discount-badge-content');

	if (priceEl) priceEl.textContent = formatCents(currentTotal);
	if (compareAtPriceEl) {
		if (compareTotal > currentTotal) {
			compareAtPriceEl.textContent = formatCents(compareTotal);
			compareAtPriceEl.style.display = 'block';
		} else {
			compareAtPriceEl.style.display = 'none';
		}
	}

	if (discountBadge) {
		const discount = compareTotal - currentTotal;
		discountBadge.style.display = discount > 0 ? '' : 'none';
		if (discount > 0) {
			discountBadge.textContent = `${window.localeStrings.savings} ${formatCents(discount)}`;
		}
	}
}

function updateGlobalCrossSellPrices(parentVariantId, currentTotal, compareTotal) {
	const currentVariantId = getActiveVariantId();
	if (currentVariantId !== Number(parentVariantId)) return;

	document.querySelectorAll('.cross-sell-price__value').forEach((el) => (el.textContent = formatCents(currentTotal)));
	document.querySelectorAll('.cross-sell-compare-at__value').forEach((el) => {
		const wrapper = el.closest('.cross-sell-compare-at');
		if (!wrapper) return;

		if (compareTotal > currentTotal) {
			el.textContent = formatCents(compareTotal);
			wrapper.style.display = '';
		} else {
			wrapper.style.display = 'none';
		}
	});
}

// HELPERS
let moneyFormatter;

function getMoneyFormatter() {
	if (moneyFormatter) return moneyFormatter;

	try {
		moneyFormatter = new Intl.NumberFormat(Shopify.locale, {
			style: 'currency',
			currency: Shopify.currency.active,
		});
	} catch {
		moneyFormatter = new Intl.NumberFormat('de-DE', {
			style: 'currency',
			currency: 'EUR',
		});
	}
	return moneyFormatter;
}

function formatCents(cents) {
	const n = Number.isFinite(cents) ? cents : 0;
	return getMoneyFormatter().format(n / 100);
}

function getActiveVariantId() {
  return document.querySelector('variant-picker')?.selectedVariant?.id || 0;
}
function getCrossSellRoot(parentVariantId) {
	return document.querySelector(`.cross-sell-variants[data-parent-variant-id="${parentVariantId}"]`);
}
